import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";


//Outlet means the inner component
const ProtectedRoute = () => {
    const { loading, isAuthenticated } = useSelector((state) => state.auth);
    return (
        !loading &&

        <Fragment>
            {isAuthenticated ? <Outlet /> : <Navigate to="/login" />}
        </Fragment>

    )

};

export default ProtectedRoute;